import {
  SET_ACTIVE,
  SET_LEAVE_INTENTION,
  SET_CONTACT_INTENTION,
  SET_SCROLL,
  SET_STATUS,
  SET_ID,
  SET_VERSION,
  SET_EXTERNAL,
  SET_PACKAGE,
  SET_PREPACKAGE,
  SET_TRACKING_PACKAGE,
  SET_AVAILABLE_NUMBERS,
  SET_SETTINGS_NAME,
  SET_FRAME_VISIBILITY,
  SET_FRAME_URL,
  SET_AUTH,
  SET_AUTH_TOKEN,
  SET_SALES_GATEWAY,
  SET_MODE,
  SET_REFERRAL,
  SET_EDITABLE,
  SET_AS_BUNDLE,
  SET_PORTABLE_INFO
} from './types';

export default {
  [SET_ACTIVE](state, activePackage) {
    state.activePackage = activePackage;
  },

  [SET_LEAVE_INTENTION](state, intention) {
    state.leaveIntention = intention;
  },

  [SET_CONTACT_INTENTION](state, payload) {
    state.contactIntention = payload;
  },

  [SET_SCROLL](state, hasScroll) {
    state.hasScroll = hasScroll;
  },

  [SET_STATUS](state, status) {
    state.status = status;
  },

  [SET_ID](state, id) {
    state.id = id;
  },

  [SET_VERSION](state, version) {
    state.version = version;
  },

  [SET_EXTERNAL](state, payload) {
    state.external = payload;
  },

  [SET_PACKAGE](state, payload) {
    window.simulationPackage = window.simulationPackage || payload;

    state.package = payload;
  },

  [SET_PREPACKAGE](state, payload) {
    state.prePackage = payload;
  },

  [SET_TRACKING_PACKAGE](state, payload) {
    state.trackingPackage = payload;
  },

  [SET_AVAILABLE_NUMBERS](state, payload) {
    state.availableNumbers = payload;
  },

  [SET_SETTINGS_NAME](state, payload) {
    state.settingsName = payload;
  },

  [SET_FRAME_VISIBILITY](state, payload) {
    state.isFrameVisible = payload;
  },

  [SET_FRAME_URL](state, payload) {
    state.frameUrl = payload;
  },

  [SET_AUTH](state, payload) {
    state.authed = payload;
  },

  [SET_AUTH_TOKEN](state, payload) {
    state.authToken = payload;
  },

  [SET_SALES_GATEWAY](state, payload) {
    state.salesGateway = payload;
  },

  [SET_MODE](state, payload) {
    state.mode = payload;
  },

  [SET_REFERRAL](state, payload) {
    state.referral = payload;
  },

  [SET_EDITABLE](state, payload) {
    state.editable = payload;
  },

  [SET_AS_BUNDLE](state, payload) {
    state.isBundle = payload;
  },
  [SET_PORTABLE_INFO](state, payload) {
    state.isInfoVisible = payload;
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/simulation/mutations.js